import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/home.jpg'
import _imports_1 from '../assets/home_m.jpg'


const _withScopeId = n => (_pushScopeId("data-v-841aa0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "vh-100 position-relative",
  id: "home"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-100 w-100 d-none d-lg-block",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-100 w-100 d-lg-none",
  src: _imports_1
}, null, -1))
const _hoisted_4 = { class: "position-absolute top-50 start-0 w-100 text-light" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Hi! I'm Shayne Chang.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoTyperVue = _resolveComponent("AutoTyperVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_AutoTyperVue, {
        componentTag: "h3",
        text: _ctx.typeText,
        typingDelay: "100",
        deletingDelay: "50"
      }, null, 8, ["text"])
    ])
  ]))
}